// components/modals/app-modals/OnboardingModal.jsx

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import BaseModalApp from '../../../components/modals/app-modals/BaseModalApp';
import OnboardingForm from './components/OnboardingForm';

const OnboardingModal = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setStep(0);
    }
  }, [isOpen]);

  const handleOnboardingComplete = () => {
    setStep(0);
    onRequestClose();
  };

  return (
    <BaseModalApp
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Onboarding Modal"
      className="ReactModal__Content modal--app modal--750px"
    >
      <h2 style={{ marginTop: 0, marginBottom: '1.5rem' }}>
        {t('welcome', 'Welcome')}
      </h2>

      <OnboardingForm
        step={step}
        setStep={setStep}
        onComplete={handleOnboardingComplete}
      />
    </BaseModalApp>
  );
};

export default OnboardingModal;
